import { createFileRoute } from '@tanstack/react-router'
import { CRT_ROUTES, toStaticData } from '../../crt-route-config'

export const Route = createFileRoute('/_auth/_modules/crt/admin/roles')({
  staticData: toStaticData(CRT_ROUTES['/crt/admin/roles']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
